import { gql } from '@apollo/client'

export const AddNewProductTypeInputFragment = gql`
    fragment addNewProductType on ProjectElementNode {
        id
        elementId
        baseElementId
        nodeOrder
        isInProject
        elementType
        text
        treePath
        parentNodeId
        projectId
        isHidden
        parentTreePath
        isSearchResult
        hasChildren
        isLastSubAssembly
        isProjectOnly
        isBestPractice
        isGlobalBestPractice
        hasBestPractice
        isMasterSpecClone
    }
`
